/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Location_AreaInputs */

const vi_camera_location_area = /** @type {(inputs: Camera_Location_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vùng trồng`)
};

/**

* @param {Camera_Location_AreaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_location_area = /** @type {((inputs?: Camera_Location_AreaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Location_AreaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_location_area(inputs)
});